import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as d3 from 'd3';
import usMapData from '../modules/maps';

export default function StateMap({
  width, height, color, stateCode,
}) {
  const svgRef = useRef(null);

  useEffect(() => {
    async function renderMap() {
      const svg = d3.select(svgRef.current)
        .attr('width', width)
        .attr('height', height)
        .html(null); // clear svg for re-render on resize

      // get the state object
      const state = usMapData.features.filter((d) => (d.properties.id === `US-${stateCode.toUpperCase()}`))[0];

      // using fitSize to fit the projection within the viewport
      const projection = d3.geoMercator().fitSize([width, height], state);

      // Define path generator
      const path = d3.geoPath().projection(projection);

      svg.append('path')
        .datum(state)
        .attr('class', 'outline')
        .attr('d', path)
        .attr('id', 'land')
        .style('fill', color)
        .style('stroke-width', '1.5')
        .style('stroke', color);
    }

    renderMap();
  }, [width, height, stateCode, color]);

  return (<svg ref={svgRef} />);
}

StateMap.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  stateCode: PropTypes.string,
};

StateMap.defaultProps = {
  height: 100,
  width: 200,
  color: '#fff',
  stateCode: 'NY',
};
